// Mezcla default purchase order — letterhead, PO header box, bars/cases item table, bars-by-product-group summary.
// Schema + mappings are the runtime contract.
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const mezclaPurchaseOrderV2FileDataSchema = yup.object().shape({
  issuer: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    addressLine1: yup.string().nullable().optional(),
    addressLine2: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  vendor: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    addressLine1: yup.string().nullable().optional(),
    addressLine2: yup.string().nullable().optional(),
  }),
  shipTo: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    addressLine1: yup.string().nullable().optional(),
    addressLine2: yup.string().nullable().optional(),
  }),
  orderNumber: yup.string().nullable().optional(),
  dateSubmitted: yup.string().nullable().optional(),
  deliveryByDate: yup.string().nullable().optional(),
  authorizedByName: yup.string().nullable().optional(),
  authorizedByTitle: yup.string().nullable().optional(),
  items: yup
    .array()
    .of(
      yup.object().shape({
        itemCode: yup.string().nullable().optional(),
        description: yup.string().nullable().optional(),
        barsQty: yup.string().nullable().optional(),
        masterCasesQty: yup.string().nullable().optional(),
        unitCost: yup.string().nullable().optional(),
      }),
    )
    .required(),
  barsByProductGroup: yup
    .array()
    .of(
      yup.object().shape({
        groupCode: yup.string().nullable().optional(),
        groupName: yup.string().nullable().optional(),
        barsQty: yup.string().nullable().optional(),
      }),
    )
    .required(),
})

export type MezclaPurchaseOrderV2FileData = yup.InferType<
  typeof mezclaPurchaseOrderV2FileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<MezclaPurchaseOrderV2FileData>

/** Each leaf is a stable GeneratedFileField UUID (or null for computed/derived fields). */
export const mezclaPurchaseOrderV2FileMappings: RequiredFileData = {
  issuer: {
    companyName: 'e907917e-a268-4cb0-9e87-662764e6e6b1',
    addressLine1: '0725576a-41aa-4589-848d-1a70b0ac4048',
    addressLine2: '9c81ebcb-dd84-4d9e-a826-82359cc9ec21',
    emailAddress: '3a0eaedc-9a62-4fcf-905d-37708bc6d57d',
  },
  vendor: {
    companyName: 'ae6f98e2-ab98-4908-93ce-f65cbe0eac9a',
    addressLine1: '644e8226-83d4-4049-8f9e-9eb63d130bdd',
    addressLine2: 'd403e302-2738-4899-aff2-7bf807fc52a2',
  },
  shipTo: {
    companyName: '27bffb4a-2343-40d1-b428-457a408b6293',
    addressLine1: 'a6000470-8569-4f60-bb45-3115d65f9f46',
    addressLine2: 'd0b6423e-6cc0-4d8e-a00e-5c6be12bf1c9',
  },
  orderNumber: 'c0d833da-b02b-44cf-8c89-8713bd94e372',
  dateSubmitted: '2ba96f8a-ba32-499a-ae45-3768f27dff7d',
  deliveryByDate: '438c2eba-cf5e-4521-8704-88eba70d0f84',
  authorizedByName: 'b1f71bdf-f873-41d7-b506-255590b0e7dc',
  authorizedByTitle: '1249a64c-0367-4532-8fa7-0796f4c7edc6',
  items: [
    {
      itemCode: 'a9214aa1-66c7-4f79-bfc8-b4315e0c7965',
      description: 'e2157d3e-8c0a-4cb9-a176-1d8d5fbfb223',
      barsQty: 'a31df3d5-9aa7-4247-8e85-88c735e0a20e',
      masterCasesQty: '5d3f0b83-7e14-445f-9671-f74cfda9f27e',
      unitCost: 'd2f8136e-f5d0-43a2-9e70-3d6da09824c5',
    },
  ],
  barsByProductGroup: [
    {
      groupCode: '5fe9dfc1-1808-4db3-9fb6-23ca4619a0b8',
      groupName: 'd56d0f12-2411-455c-b307-51fe3ab2fcb6',
      barsQty: '374a5948-b750-4984-abc8-9ca05a9e0bc7',
    },
  ],
}
